import * as React from 'react';
import IImageEditor from './IImageEditor';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import ImpersonateButton from '../../components/ImpersonateButton';
import DeleteButton from '../../components/common/DeleteButton';
import TelephoneLink from '../../components/common/TelephoneLink';
import EmailLink from '../../components/common/EmailLink';

interface ImageEditorUserListRowProps {
    imageEditor: IImageEditor;
    key: number;
    onDelete: (id: number) => void;
    onEdit: (id: number) => void;
}

const ImageEditorListRow = (props: ImageEditorUserListRowProps) => {
    return (
        <tr>
            <td>{props.imageEditor.name}</td>
            <td>{Translate(props.imageEditor.role)}</td>
            <td>
                <EmailLink>{props.imageEditor.email}</EmailLink>
            </td>
            <td>
                <TelephoneLink>{props.imageEditor.phoneNumber}</TelephoneLink>
            </td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <DeleteButton
                        onDelete={() => props.onDelete(props.imageEditor.id)}
                        text={Translate('image-editors/list/row/delete/remove-this-user')}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('image-editors/list/row/button-label/delete')}
                    </DeleteButton>
                    <Button
                        onClick={props.onEdit.bind(null, props.imageEditor.id)}
                        bsStyle="primary"
                    >
                        <i className="material-icons">edit</i>{' '}
                        {Translate('image-editors/list/row/button-label/edit')}
                    </Button>
                    <ImpersonateButton
                        userId={props.imageEditor.id}
                        afterLoginPath="/unedited-orders"
                    />
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default ImageEditorListRow;
